/* eslint-disable react/prop-types */
/* eslint-env browser */
import React from 'react'

import { useTranslator } from '../TranslatorProvider'

interface CatchMethodsFullListProps {
  host: string
  hostPath: string
  locale: string
  description?: string
  catchMethods: {
    id: string
    name: string
  }[]
}

export const CatchMethodsFullList: React.FC<CatchMethodsFullListProps> = ({ catchMethods, description, locale }) => {
  const t = useTranslator(locale)

  return (
    <div>
      <div className="columns is-multiline has-padding-horizontal-medium">
        {description && (
          <div className="column is-12">
            <p>{description}</p>
            {/*
            <p>
              <a href="/map">{`${t('hydro.country.searchInput.mapLink')} >`}</a>
            </p>
            */}
          </div>
        )}
        <div className="column is-12">
          <ul>
            {catchMethods.map(catchMethod => {
              return (
                <div key={catchMethod.id} className="media">
                  <div className="media-content is-self-centered">{catchMethod.name}</div>
                </div>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
